<template>
    <v-form @submit.prevent="onSubmit" novalidate class="">
      <Fields
        v-bind="{fields, object: formData, errors: formErrors}">
      </Fields>

      <v-btn type="submit" color="primary">Wyślij</v-btn>
    </v-form>
</template>

<script>
import {createComment, updateComment} from './api'
import _ from 'lodash'
import { mapState } from 'vuex'
import Fields from '@/forms/Fields'
import formMixin from '@/utils/formMixin'

export default {
  components: {Fields},
  mixins: [formMixin],
  props: {
    month: {
      type: Object
    },
    comment: {
      type: Object,
      default: function () {
        return {
          month: this.month.format('YYYY-MM-DD')
        }
      }
    }
  },
  data () {
    return {
      isUpdate: false
    }
  },
  computed: {
    ...mapState(['runner']),
    fields () {
      return [
        {comp: 'textarea', id: 'comment', label: 'Komentarz'}
      ]
    },
    message () {
      return this.isUpdate ? 'Komentarz został edytowany' : 'Komentarz został dodany'
    }
  },
  created () {
    this.formData = _.cloneDeep(this.comment)
    if (this.comment.id) {
      this.isUpdate = true
    }
  },
  methods: {
    submit (data) {
      if (this.isUpdate) {
        return updateComment(this.runner, data)
      } else {
        return createComment(this.runner, data).then((data) => {
          this.formData = {
            month: this.month.format('YYYY-MM-DD')
          }
          this.validation.reset()
          return data
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/PlanCommentForm.vue